import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';

class AccountStore {
  avatar = null;
  avatarUrl = '';
  nickname = '';
  gender = '';

  constructor() {
    makeAutoObservable(this)
  }

  /**
   * 修改昵称
   */
  async doModifyNickname() {
    try {
      const { nickname } = this;
      await Api.modifyUserInfo({
        nickname
      });

      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * 修改性别
   */
  async doModifyGender() {
    try {
      let { gender } = this;
      if (gender === 0) {
        gender = '男';
      } else {
        gender = '女';
      }
      await Api.modifyUserInfo({
        gender
      });
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * 修改头像
   */
  async doModifyAvatar() {
    try {
      const { avatar } = this;
      await Api.modifyUserInfo({ avatar });
      return true;
    } catch (error) {
      return false;
    }
  }
}

const store = new AccountStore();

export default store;
